import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../common/html/element'
import { CustomPrice } from '../../common/order/customPrice'
import { Tooltip } from '../../common/tooltip'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../helpers/EventEmitter'
import { COMPONENTS } from '../../routers/constants'
import { USER_TYPE } from '../../utils/authorization'
import { CHECKBOX_TRADE_DISCOUNT, STEP, TYPE_STATUS_ORDER } from '../constant'
import { formatPrice } from '../helper'
import {
  getPrice,
  resetStore,
  selectCheck,
  selectCheckDisCountAndVoucher,
  selectDataPlaceOrder,
  selectDiscountOrder,
  selectTotalPrice,
  selectVoucher,
} from '../store/slice'
import { postOrderZero } from '../store/thunk'
import { CheckOutButton } from './CheckOutButton'

export const SummaryPrice = ({
  nextStep,
  openPopupTradeDiscount,
  vatPercentage,
  userType,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const totalPrice = useSelector(selectTotalPrice('totalPrice'))
  const discountedPrice = useSelector(selectTotalPrice('discountedPrice'))
  const discountValue = useSelector(selectTotalPrice('discountValue'))
  const dataVoucher = useSelector(selectVoucher)
  const check = useSelector(selectCheck)
  const discountOrder = useSelector(selectDiscountOrder)
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const dataItemCart = useSelector(selectDataPlaceOrder)

  const lengthChecked = Object.keys(check).length
  const isDisableCheckout =
    [USER_TYPE.TRIAL].includes(userType.userTypeId) || lengthChecked === 0

  const priceDiscountRaw = checkDiscountAndVoucher[
    CHECKBOX_TRADE_DISCOUNT.DISCOUNT
  ]
    ? discountedPrice * discountOrder?.discountPercentage
    : 0
  const priceVoucher = checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER]
    ? discountedPrice * dataVoucher?.discountPercentage
    : dataVoucher?.discountAmount
    ? dataVoucher?.discountAmount
    : 0
  const priceDiscount = formatPrice(priceDiscountRaw + priceVoucher)
  const priceVAT = (discountedPrice - priceDiscount) * vatPercentage
  const priceTotalFinal = discountedPrice - priceDiscount + priceVAT

  const onCheckOut = () => {
    if ([USER_TYPE.TRIAL].includes(userType.userTypeId)) {
      return
    }

    if (lengthChecked === 0) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [<Translate value="cartAndOrders.message.m17" />],
      })
      return
    }

    if (Math.max(priceTotalFinal, 0) === 0) {
      dispatch(
        postOrderZero({
          order: {
            details: [...dataItemCart],
            discountId: checkDiscountAndVoucher[
              CHECKBOX_TRADE_DISCOUNT.DISCOUNT
            ]
              ? discountOrder?.id
              : undefined,
            voucherCode: checkDiscountAndVoucher[
              CHECKBOX_TRADE_DISCOUNT.VOUCHER
            ]
              ? dataVoucher?.code
              : undefined,
          },
        }),
      )
        .unwrap()
        .then((code) => {
          window.location.href = code?.redirectUrl
        })
        .catch(() => {
          navigate(
            `${COMPONENTS.cartAndOrders.route}?step=${STEP.ORDER_CONFIRMATION}&PaymentStatus=${TYPE_STATUS_ORDER.UNPAID}`,
          )
          dispatch(resetStore())
        })
      return
    }

    nextStep()
  }

  useEffect(() => {
    dispatch(getPrice())
  }, [lengthChecked])

  return (
    <div className="w70">
      <div className="pl2 w75">
        <div className="dFlex alignItemsCenter justifyContentBetween">
          <div className="fw600">
            <Translate value="cartAndOrders.cart.totalPrice" />
          </div>
          <CustomPrice
            value={totalPrice}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
            }}
            styleIcon={{ width: 18, height: 18 }}
          />
        </div>
        <div className="mt1 dFlex alignItemsCenter justifyContentBetween">
          <div className="fw600">
            <Translate value="cartAndOrders.cart.totalDiscount" />
          </div>
          <CustomPrice
            value={discountValue}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
            }}
            styleIcon={{ width: 18, height: 18 }}
          />
        </div>
        <div className="mt1 dFlex alignItemsCenter justifyContentBetween positionRelative">
          <div className="fw600">
            <Translate value="cartAndOrders.cart.tradeDiscount" />
          </div>
          <CustomPrice
            value={totalPrice ? priceDiscount : 0}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
            }}
            styleIcon={{ width: 18, height: 18 }}
          />
          <Element
            className="positionAbsolute cursorPointer"
            style={{ right: '-30%', color: '#2C73E8', fontStyle: 'italic' }}
            onClick={openPopupTradeDiscount}
          >
            <Translate value="cartAndOrders.cart.selectOrEnter" />
          </Element>
        </div>
        <div className="mt1 dFlex alignItemsCenter justifyContentBetween">
          <div className="fw600">VAT</div>
          <CustomPrice
            value={Math.max(priceVAT, 0)}
            style={{
              color: '#0553A5',
              fontSize: 14,
              fontWeight: 600,
            }}
            styleIcon={{ width: 18, height: 18 }}
          />
        </div>
      </div>
      <div className="mt1 dFlex alignItemsCenter justifyContentBetween">
        <div className="w75 pl2 dFlex alignItemsCenter justifyContentBetween">
          <div className="fw600">
            <Translate value="cartAndOrders.cart.total" />
          </div>
          <CustomPrice
            value={Math.max(priceTotalFinal, 0)}
            style={{
              color: '#3DA967',
              fontSize: 14,
              fontWeight: 600,
            }}
            styleIcon={{ width: 18, height: 18 }}
          />
        </div>

        {USER_TYPE.TRIAL === userType.userTypeId ? (
          <div>
            <Tooltip tooltipContent="cartAndOrders.message.m20" isI18n>
              <CheckOutButton
                isDisableCheckout={isDisableCheckout}
                onCheckOut={onCheckOut}
              />
            </Tooltip>
          </div>
        ) : (
          <CheckOutButton
            isDisableCheckout={isDisableCheckout}
            onCheckOut={onCheckOut}
          />
        )}
      </div>
    </div>
  )
}
